module.exports = __webpack_public_path__ + "img/hrlogo.69fe5969.svg";